const steps = [
  'General Info',
  'Business Profile',
  'Capabilities',
  'Past Performance',
  'Bonding',
  'Insurance and Safety',
  'Security and Certifications',
  'Compliance',
  'Signature',
];

const whitespaceRE = /(\s+)/g;
const titleToPath = (title: string) => {
  const path = '/registration/' + title.toLowerCase().replace(whitespaceRE, '-');
  return path;
}

const getPath = (steps: string[], index: number): string => {
  if (steps.length <= index)
    return '';
  return titleToPath(steps[index]);
}

const getStep = (steps: string[], path: string): number => {
  const index = steps.findIndex(step => {
    return path === titleToPath(step);
  });
  return (index === -1 ? 0 : index);
}

export {
  steps as defaultSteps,
  getPath,
  getStep,
};
